import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wornPercentageToEval'
})
export class WornPercentageToEvalPipe implements PipeTransform {

    transform(wornPercentage: number): string {
        if(!wornPercentage && wornPercentage !== 0)
            return 'U';
        else if (wornPercentage <= 30)
            return 'A';
        else if (wornPercentage <= 50)
            return 'B';
        else if (wornPercentage <= 70)
            return 'C';
        else
            return 'X';
  }
}
